interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav
      aria-label="面包屑导航"
      className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-600"
    >
      <a href="/" className="transition-colors hover:text-primary-700">
        首页
      </a>
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line"></i>
          {item.to ? (
            <a href={item.to} className="transition-colors hover:text-primary-700">
              {item.label}
            </a>
          ) : (
            <span className="text-foreground-900">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}